import * as Popup from "../framework/components/popup.js";
import * as Dialog from "../framework/dialog";
import { DOCUMENT_ACCESS_GROUPS, HOME_FOLDER_ID } from "./documents_consts.js";
import { filestackPicker, pickDocuments } from "../framework/uploader";
import { getUITranslation } from "../utils/get_ui_translation";
import * as toast from "../framework/components/toast.js";
import { maybeScrollTo } from "../framework/scroll-to.js";
import { setParam } from "../framework/query.js";

$(function () {
  $(document)
    .on("click", ".add-document", onAddDocument)
    .on("click", ".add-addressed-document", onAddAddressedDocument)
    .on("click", "#documents-recipient-search", onFilterRecipients)
    .on("click", ".recipient-group-checkbox", onSelectRecipientsByGroup)
    .on("click", ".fold-show-recipients", onToggleRecipientsList)
    .on("change", ".toggle-filestack-button-state", onToggleInitFilestackButtonState)
    .on("click", ".documents__delete-document-button", onInitialiseDeleteDocumentModal)
    .on("click", "#open-folder-picker-for-documents", onOpenFoldersPickerModal)
    .on("change", ".recipient-selector", onCheckboxesConsistency)
    .on("click", ".js-open-document-delete-popup", onSetDocumentDataForDelete);
});

document.addEventListener("alpine:initialized", () => {
  // scrollIntoView don't work correctly when the target is child of an x-cloak
  // cause the element is not displayed when we try to scroll to it.
  // The display:none added by the x-cloak is removed after the alpine:initialized event is sent
  // so we wait 100ms to be sure the target is visible
  setTimeout(() => {
    maybeScrollTo("uploader_document_id");
  }, 100);
});

//------------------------------------------------------------------------------
// onAddDocument
//------------------------------------------------------------------------------
function onAddDocument(e) {
  e.preventDefault();
  let $e = $(e.target).closest("[data-relation]");
  let postUrl = $e.attr("data-post-url");
  const qs_create_attr = $e.attr("data-qs-create");
  let relation = $e.attr("data-relation");

  let fileData = JSON.parse(relation);

  pickDocuments(function (success, blobs) {
    if (!success) return;

    let files = _.map(blobs, function (blob) {
      return _.merge(_.cloneDeep(fileData), {
        url: blob.url,
        filename: blob.filename,
        mime: blob.mimetype,
        size: blob.size,
      });
    });

    let data = {
      files: JSON.stringify(files),
    };

    ajax({
      method: "POST",
      url: postUrl,
      data: data,
      success: function (data) {
        if (data.success) {
          if (qs_create_attr != null) {
            const qs_create = JSON.parse(qs_create_attr);
            setParam("uploader_document_id", qs_create);
          }
          location.reload();
        } else {
          Dialog.alert(getUITranslation("Erreur"), data.error, "error");
        }
      },
      error: function () {
        console.error("Error during the documents loading");
        Dialog.alert("", getUITranslation("Erreur lors du chargement des documents."), "error");
      },
    });
  });
}

//------------------------------------------------------------------------------
// onAddAddressedDocument
//------------------------------------------------------------------------------
function onAddAddressedDocument(e) {
  e.preventDefault();
  let $e = $(e.target).closest("[data-relation]");
  let postUrl = $e.attr("data-post-url");
  let relation = $e.attr("data-relation");
  let fileData = JSON.parse(relation);

  let group = $("#document_recipient").find("option:selected").parent().data("group");
  let recipient = $("#document_recipient").find("option:selected").val();

  pickDocuments(function (success, blobs) {
    if (!success) return;

    let files = _.map(blobs, function (blob) {
      return _.merge(_.cloneDeep(fileData), {
        url: blob.url,
        filename: blob.filename,
        mime: blob.mimetype,
        size: blob.size,
        recipient_type: group,
        recipient_id: parseInt(recipient),
      });
    });

    let data = {
      files: JSON.stringify(files),
    };

    ajax({
      method: "POST",
      url: postUrl,
      data: data,
      success: function (data) {
        if (data.success) {
          location.reload();
        } else {
          Dialog.alert(getUITranslation("Erreur"), data.error, "error");
        }
      },
      error: function () {
        console.error("Error during the documents loading");
        Dialog.alert("", getUITranslation("Erreur lors du chargement des documents."), "error");
      },
    });
  });
}

function onSetDocumentDataForDelete(event) {
  event.preventDefault();
  const documentId = event.currentTarget.dataset.documentId;
  const currentlySelectedFolder = document.querySelector(".documents__folder--checked");

  document.getElementById("document-delete-input-id").value = documentId;
  document.getElementById("document-delete-selected-folder-name").value = currentlySelectedFolder.dataset.folderName;
}

async function onInitialiseDeleteDocumentModal(event) {
  event.preventDefault();
  const path = event.currentTarget.dataset.path;
  const element = event.currentTarget.parentElement.parentElement;
  const id = event.currentTarget.getAttribute("toast-id");
  const deletionConfirmed = await Dialog.confirmCancel(
    getUITranslation("Attention"),
    getUITranslation("Voulez-vous vraiment supprimer ce document ?")
  );
  if (deletionConfirmed) {
    deleteDocument(path, element, id);
  }
}

function deleteDocument(path, element, id) {
  ajax({
    type: "POST",
    url: path,
    error: function () {
      console.error("Error deleting document");
    },
    success: function (data) {
      if (data.success) {
        toast.show("#documents-delete-success-toast-" + id);
        element.remove();
      } else {
        toast.show("#documents-delete-error-toast-" + id);
        console.error("Error deleting document");
      }
    },
  });
}

function onOpenFoldersPickerModal(event) {
  event.preventDefault();
  const recipientsModal = document.getElementById("document-recipient-selector-modal");
  Popup.close(recipientsModal);

  const foldersModal = document.getElementById("documents-folder-selector-modal");
  Popup.open(foldersModal);
}

// By default, all of the recipients should not be shown (only groups shall be shown).
function onToggleRecipientsList(event) {
  const recipientGroup = event.currentTarget.dataset.recipientGroup;
  const recipientsList = document.querySelector(`.listed-recipients[data-recipient-group="${recipientGroup}"]`);
  const recipientsListCaret = document.querySelector(`.icon__fold-show-recipients[data-recipient-group=${recipientGroup}]`);

  recipientsList.classList.toggle("hidden-recipients");
  recipientsListCaret.classList.toggle(
    "icon__fold-show-recipients--selected",
    !recipientsList.classList.contains("hidden-recipients")
  );
}

function onSelectRecipientsByGroup(event) {
  const isAllRecipientsCheckboxChecked = document.getElementById("recipients-group-selector-all").checked;
  const recipientGroup = event.currentTarget.dataset.recipientGroup;
  const isChecked = event.currentTarget.checked;
  if (recipientGroup === DOCUMENT_ACCESS_GROUPS.all) {
    selectAllRecipients(isChecked);
  } else {
    const recipientsListByGroup = document.querySelectorAll(`[data-recipient-group="${recipientGroup}"]`);
    recipientsListByGroup.forEach((input) => (input.checked = isChecked));
  }

  // If `all recipients` is selected and `recipient group` has been unselected
  // Then unselect `all recipients` checkbox
  if (isAllRecipientsCheckboxChecked && !isChecked) {
    document.getElementById("recipients-group-selector-all").checked = false;
  }
}

function selectAllRecipients(isChecked) {
  const allRecipientsList = document.querySelector(".recipients-list__block");
  const recipientsInputs = allRecipientsList.querySelectorAll("input");

  recipientsInputs.forEach((input) => (input.checked = isChecked));
}

function onFilterRecipients(event) {
  event.preventDefault();
  const searchInput = document.getElementById("documents-recipient-search");
  const allRecipientsSelector = document.querySelector(".recipient-group__title-all");

  searchInput.addEventListener("input", () => {
    const inputedValue = searchInput.value.toLowerCase();
    // Hide `share between all recipients` title
    allRecipientsSelector.style.display = "none";

    // Filter guests
    const listedGuests = document.getElementsByClassName("recipient-selector");
    [...listedGuests].forEach((guest) => {
      const guestFullname = guest.textContent.toLowerCase();

      if (guestFullname.includes(inputedValue)) {
        guest.style.display = "flex";
      } else {
        guest.style.display = "none";
      }
    });

    // Show the `recipient group` checkbox and `share between all recipients` title
    if (inputedValue.length === 0) allRecipientsSelector.style.display = "flex";
  });
}

// Check, if initialize filestack picker button can be enabled
function onToggleInitFilestackButtonState() {
  const initFilestackButton = document.querySelector("#open-folder-picker-for-documents");
  const listedGuests = document.getElementsByClassName("document-recipient__checkbox");

  // Check if at least one `recipient` is selected
  const isAnyChecked = [...listedGuests].some((guest) => guest.checked);
  initFilestackButton.disabled = !isAnyChecked;
}

/*
This function is used, when it may face data inconsistency.
1. If someone selects an option for:
- `all recipients`,
- `all instructors`,
- `all trainees`,
- `all funding_agencies`,
- `all companies`,
and unselects the given recipient (e.g. `instructor`), then following things should happen:
- unselect the `all recipients` checkbox (if selected),
- unselect the given `recipient group` checkbox (if selected).
*/

function onCheckboxesConsistency(event) {
  const triggeredRecipient = event.target.dataset.recipientGroup;
  const allRecipientsOfGivenGroup = document.querySelectorAll(
    `input[data-recipient-group='${triggeredRecipient}']:not(.recipient-group-checkbox)`
  );
  const isRecipientGroupChecked = document.querySelector(`input#recipients-group-selector-${triggeredRecipient}`).checked;
  const isAllRecipientsCheckboxChecked = document.getElementById("recipients-group-selector-all").checked;
  const isTriggeredRecipientUnchecked = !event.target.checked;

  // Unselect `all recipients` checkbox
  if (isAllRecipientsCheckboxChecked && isTriggeredRecipientUnchecked) {
    document.getElementById("recipients-group-selector-all").checked = false;
  }

  // Unselect `triggered recipient group` checkbox
  if (isRecipientGroupChecked && isTriggeredRecipientUnchecked) {
    document.querySelector(`input#recipients-group-selector-${triggeredRecipient}`).checked = false;
  }

  // If all `recipients` of a given type are selected, and there is more than one `recipient` in the list,
  // then the `recipient_group` should be also checked
  const areAllRecipientsOfGivenGroupChecked = [...allRecipientsOfGivenGroup].every((recipientInput) => recipientInput.checked);

  if (areAllRecipientsOfGivenGroupChecked && [allRecipientsOfGivenGroup].length > 1) {
    document.querySelector(`input#recipients-group-selector-${triggeredRecipient}`).checked = true;
  }
}

export async function onCloseModalAndInitializePicker(event) {
  event.preventDefault();
  // Close modal
  const documentsModal = document.getElementById("documents-folder-selector-modal");
  Popup.close(documentsModal);

  // Init filestack
  const segregatedRecipients = { access_group: [] };
  const trainingSessionId = event.currentTarget.dataset.trainingSessionId;
  const selectedFolder = document.querySelector(".documents-modal__folders-checkbox:checked");
  const folderId = selectedFolder.dataset.folderId;
  const folderName = selectedFolder.dataset.folderName;
  const recipients = document.querySelector(".recipients-list__block");

  // Get segregated recipients by recipient type
  [...recipients.querySelectorAll("input:checked")].forEach((user) => {
    const recipientGroup = user.dataset.recipientGroup;
    const recipientId = user.dataset.recipientIndicator;
    if (!segregatedRecipients[recipientGroup] && recipientGroup) {
      segregatedRecipients[recipientGroup] = [];
    }

    if (recipientId) {
      segregatedRecipients[recipientGroup].push(recipientId);
    } else {
      segregatedRecipients["access_group"].push(recipientGroup);
    }
  });

  const { filesUploaded } = await filestackPicker({
    path: "/documents/filestack/",
    maxFiles: 20,
  });

  if (filesUploaded?.length) {
    const files = filesUploaded.map((file) => ({
      url: file.url,
      filename: file.filename,
      mime: file.mimetype,
      size: file.size,
      training_session_id: trainingSessionId,
      ...(folderId !== HOME_FOLDER_ID && { folder_id: folderId }),
    }));

    return {
      files: JSON.stringify(files),
      recipients: JSON.stringify(segregatedRecipients),
      folder_id: folderId !== HOME_FOLDER_ID ? folderId : null,
      folder_name: folderName,
    };
  }
}
